/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiRequestDto } from '../model/apiRequestDto';
import { InvoiceApprovalResults } from '../model/invoiceApprovalResults';
import { InvoiceApprovalSubmitResult } from '../model/invoiceApprovalSubmitResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InvoiceApprovalService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns a string value to indicate current logged in user can view and interact with invoice approval.
     * Sample Call  http://URL/api/InvoiceApproval/CanViewInvoiceApproval
     * @param requestParams Contains request parameters: orgUnits
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalCanViewInvoiceApproval(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public invoiceApprovalCanViewInvoiceApproval(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public invoiceApprovalCanViewInvoiceApproval(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public invoiceApprovalCanViewInvoiceApproval(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling invoiceApprovalCanViewInvoiceApproval.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/InvoiceApproval/CanViewInvoiceApproval`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the invoice approval documents that fall within the given date range for the given organization units.
     * Sample Call  http://URL/api/InvoiceApproval/GetInvoiceApprovalDocuments
     * @param requestParams Contains request parameters: start, end, orgUnits
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalGetInvoiceApprovalDocuments(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<InvoiceApprovalResults>>;
    public invoiceApprovalGetInvoiceApprovalDocuments(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InvoiceApprovalResults>>>;
    public invoiceApprovalGetInvoiceApprovalDocuments(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InvoiceApprovalResults>>>;
    public invoiceApprovalGetInvoiceApprovalDocuments(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling invoiceApprovalGetInvoiceApprovalDocuments.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InvoiceApprovalResults>>(`${this.basePath}/api/InvoiceApproval/GetInvoiceApprovalDocuments`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the excel exportable list of invoices.
     * Sample Call  http://URL/api/InvoiceApproval/GetInvoiceListWithExcel
     * @param requestParams Contains request parameters: start, end, orgUnits
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalGetInvoiceListWithExcel(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public invoiceApprovalGetInvoiceListWithExcel(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public invoiceApprovalGetInvoiceListWithExcel(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public invoiceApprovalGetInvoiceListWithExcel(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling invoiceApprovalGetInvoiceListWithExcel.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/InvoiceApproval/GetInvoiceListWithExcel`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the aggregate number of pending invoice approvals for the given set of orgUnits.
     * Sample Call  http://URL/api/InvoiceApproval/GetPendingInvoiceApprovalCount
     * @param requestParams Contains request parameters: orgUnits
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalGetPendingInvoiceApprovalCount(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public invoiceApprovalGetPendingInvoiceApprovalCount(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public invoiceApprovalGetPendingInvoiceApprovalCount(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public invoiceApprovalGetPendingInvoiceApprovalCount(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling invoiceApprovalGetPendingInvoiceApprovalCount.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/InvoiceApproval/GetPendingInvoiceApprovalCount`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifies the pending approval document to approved.
     * Sample Call  http://URL/api/InvoiceApproval/UpdateInvoiceApprovalStatus?approvalId&#x3D;1&amp;amp;userName&#x3D;me
     * @param approvalId 
     * @param userName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalUpdateInvoiceApprovalStatus(approvalId: string, userName: string, observe?: 'body', reportProgress?: boolean): Observable<InvoiceApprovalSubmitResult>;
    public invoiceApprovalUpdateInvoiceApprovalStatus(approvalId: string, userName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceApprovalSubmitResult>>;
    public invoiceApprovalUpdateInvoiceApprovalStatus(approvalId: string, userName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceApprovalSubmitResult>>;
    public invoiceApprovalUpdateInvoiceApprovalStatus(approvalId: string, userName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (approvalId === null || approvalId === undefined) {
            throw new Error('Required parameter approvalId was null or undefined when calling invoiceApprovalUpdateInvoiceApprovalStatus.');
        }

        if (userName === null || userName === undefined) {
            throw new Error('Required parameter userName was null or undefined when calling invoiceApprovalUpdateInvoiceApprovalStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (approvalId !== undefined && approvalId !== null) {
            queryParameters = queryParameters.set('approvalId', <any>approvalId);
        }
        if (userName !== undefined && userName !== null) {
            queryParameters = queryParameters.set('userName', <any>userName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<InvoiceApprovalSubmitResult>(`${this.basePath}/api/InvoiceApproval/UpdateInvoiceApprovalStatus`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Adds an approved with comments document
     *     Sample Call      http://URL/api/InvoiceApproval/UploadApprovalDocument  invoiceId and userName are sent as form data elements along with uploaded file as multipart/form-data request  In the angular UI the swagger api is not used to access this method.  Instead use the custom method UploadApprovalWithCommentsCustom   routine
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public invoiceApprovalUploadApprovalWithComments(observe?: 'body', reportProgress?: boolean): Observable<InvoiceApprovalSubmitResult>;
    public invoiceApprovalUploadApprovalWithComments(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvoiceApprovalSubmitResult>>;
    public invoiceApprovalUploadApprovalWithComments(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvoiceApprovalSubmitResult>>;
    public invoiceApprovalUploadApprovalWithComments(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<InvoiceApprovalSubmitResult>(`${this.basePath}/api/InvoiceApproval/UploadApprovalDocument`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
